import { render } from "./WebSummary.vue?vue&type=template&id=34fbc81c"
import script from "./WebSummary.vue?vue&type=script&lang=js"
export * from "./WebSummary.vue?vue&type=script&lang=js"

import "./WebSummary.vue?vue&type=style&index=0&id=34fbc81c&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__